import React from "react";
import Layout from "../../components/Layout";
import "./Hbot.css";
import image from "../../images/7.png";
import InfoCard from "src/components/InfoCard";

const hbot: React.FC = () => {
  return (
    <Layout>
      <InfoCard
        title={"Hyperbaric Oxygen Therapy (HBOT)"}
        imageTitle={"HBOT"}
        image={image}
      >
        <div className="hbot-details">
          <p>
            It is the medical use of oxygen at a level higher than atmospheric
            pressure..
          </p>
          <p>
            <strong></strong>
            The equipment required consists of a pressure chamber, which may be
            of rigid or flexible construction, and a means of delivering 100%
            oxygen.
          </p>
          <p>
            <strong></strong>
            Operation is performed to a predetermined schedule by trained
            personnel who monitor the patient and may adjust the schedule as
            required.
          </p>
          <p>
            <strong></strong>
            We can provide you with all staff needs for an HBOT center including
            hyperbaric doctors, hyperbaric nurses and hyperbaric technicians
          </p>
          <p>
            <strong></strong>
            HBOT found early use in the treatment of decompression sickness, and
            has also shown great effectiveness in treating conditions such as:
          </p>
          <p>
            <strong></strong>• Diabetes complications, such as diabetic
            foot, diabetic retinopathy, diabetic nephropathy<br></br>• Carbon
            monoxide and cyanide poisoning.<br></br>• Central retinal artery
            occlusion.<br></br>• Clostridial myositis and myonecrosis (gas
            gangrene).<br></br>• Crush injury, compartment syndrome, and other
            acute traumatic ischemia.<br></br>• Arterial gas embolism
            and decompression sickness (DCS).<br></br>• Enhancement of healing
            in selected problem wounds.<br></br>• Exceptional blood loss
            (anemia).
            <br></br>• Idiopathic sudden sensorineural hearing loss.<br></br>•
            Intracranial abscess.<br></br>• Necrotizing soft tissue infections
            (necrotizing fasciitis).<br></br>• Osteomyelitis (refractory).
            <br></br>• Delayed radiation injury (soft tissue and bony necrosis).
            <br></br>• Skin grafts and flaps (compromised).
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default hbot;
